import * as Types from '../Constants/AllConstants';

// Get all podcasts (paged)
export const GetAllPodcastsReducer = (
  state = { podcasts: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.PODCAST_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.PODCAST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        podcasts: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.PODCAST_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.PODCAST_LIST_RESET:
      return { podcasts: [] };
    default:
      return state;
  }
};

// Get podcast details
export const PodcastDetailsReducer = (state = { podcast: {} }, action) => {
  switch (action.type) {
    case Types.PODCAST_DETAILS_REQUEST:
      return { loading: true };
    case Types.PODCAST_DETAILS_SUCCESS:
      return { loading: false, podcast: action.payload };
    case Types.PODCAST_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create podcast
export const CreatePodcastReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PODCAST_CREATE_REQUEST:
      return { loading: true };
    case Types.PODCAST_CREATE_SUCCESS:
      return { loading: false, success: true, podcast: action.payload };
    case Types.PODCAST_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PODCAST_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update podcast
export const UpdatePodcastReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PODCAST_UPDATE_REQUEST:
      return { loading: true };
    case Types.PODCAST_UPDATE_SUCCESS:
      return { loading: false, success: true, podcast: action.payload };
    case Types.PODCAST_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PODCAST_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete podcast
export const DeletePodcastReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PODCAST_DELETE_REQUEST:
      return { loading: true };
    case Types.PODCAST_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.PODCAST_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PODCAST_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// Get podcast stats
export const GetPodcastStatsReducer = (state = { stats: null }, action) => {
  switch (action.type) {
    case Types.PODCAST_STATS_REQUEST:
      return { ...state, loading: true };
    case Types.PODCAST_STATS_SUCCESS:
      return { loading: false, stats: action.payload };
    case Types.PODCAST_STATS_FAIL:
      return { loading: false, error: action.payload };
    case Types.PODCAST_STATS_RESET:
      return { stats: null };
    default:
      return state;
  }
};